export const capitalFirstLetter = (str) =>
  str?.replace(/^(.)|\s+(.)/g, (c) => c.toUpperCase());
